/* eslint-disable consistent-return */
import { createAsyncThunk } from '@reduxjs/toolkit';
import create from '../../../services/api';
import API_PATH from '../../../constant/apiPath';
import { updateLoading } from '../loader';

const handleSaveUser = createAsyncThunk('customerFormDetail/saveUser', async (data: any, { dispatch }) => {
  const API = create();
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.SAVE_USER, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise to signal failure in createAsyncThunk
  }
});

const handleVerifyOTP = createAsyncThunk('customerFormDetail/verifyOTP', async (data: any, { dispatch }) => {
  const API = create();
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.VERIFY_OTP, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise to signal failure in createAsyncThunk
  }
});

const fetchResendOTP = createAsyncThunk('customerFormDetail/resendOTP', async (data: any, { dispatch }) => {
  const API = create();
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.RESEND_OTP, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise to signal failure in createAsyncThunk
  }
});

const handleInitiatePayment = createAsyncThunk('customerFormDetail/resendOTP', async (data: any, { dispatch }) => {
  const API = create();
  try {
    dispatch(updateLoading(true));
    const response:any = await API.post(API_PATH.INITIATED_PAYMENT, data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise to signal failure in createAsyncThunk
  }
});

const fetchPaymentStatus = createAsyncThunk('customerFormDetail/resendOTP', async (data: any, { dispatch }) => {
  const API = create();
  try {
    dispatch(updateLoading(true));
    const response:any = await API.get(API_PATH.PAYMENT_STATUS + data); // Adjust `any` to the correct type if known
    dispatch(updateLoading(false));
    return response.data;
  } catch (err) {
    dispatch(updateLoading(false));
    return Promise.reject(err); // Return as rejected promise to signal failure in createAsyncThunk
  }
});

export {
  handleSaveUser,
  handleVerifyOTP,
  fetchResendOTP,
  handleInitiatePayment,
  fetchPaymentStatus
};
